export default {"src":"/_next/static/media/edit-list.2d2d9703.svg","height":30,"width":16};